import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CommissionAdditionalPromotor } from 'src/app/model/commission-additional-promotor.model';
import { CommissionAdjustment } from 'src/app/model/commission-adjustment.model';
import { ComisionSimuladorService } from 'src/app/services/comision-simulador.service';

@Component({
  selector: 'app-modal-commission-adjust',
  templateUrl: './modal-commission-adjust.component.html'
})
export class ModalAdjustCommissionComponent implements OnInit {
  @Input() simulateDate:string;
  @Input() selectedCommission:CommissionAdjustment;
  @Input() comisionOriginalFinal:number;
  
  public commissionOriginal:number;
  public commissionModificada:number;
  
  public ajuste:boolean;
  public comentarioAjuste:string;
  public iCreditIdMotivo:number;
  public tipoAjuste:string;
  public viewStatus:number=0;

  
    @Output() montoAjuste2 = new EventEmitter<{ montoAjuste3: number }>();
    public montoAjuste:number;
    
  //Campos model
  public creditId:number;    
  constructor(
    private modalService: NgbModal,
    private commissionService:ComisionSimuladorService,
    private toastr:ToastrService
  ) { }

  ngOnInit() {
    console.log(this.selectedCommission)
    this.viewStatus = 1;
    this.ajuste = false;
    this.commissionOriginal = this.comisionOriginalFinal;
    this.creditId = this.selectedCommission.creditId;
    this.commissionModificada = this.commissionOriginal + this.selectedCommission.commissionAdjustmentAmount;
    if(this.selectedCommission.commissionAdjustmentAmount > 0 || this.selectedCommission.commissionAdjustmentAmount < 0){
      this.montoAjuste = this.selectedCommission.commissionAdjustmentAmount;
    }
  }

  adjustCommission(){
    this.commissionModificada= (this.commissionOriginal + this.montoAjuste);
    this.commissionModificada.toFixed(2);

    if(this.montoAjuste == 0 || this.commissionOriginal == this.commissionModificada || this.commissionModificada < 0){
      this.ajuste = false;
      if(this.commissionModificada < 0){
        this.toastr.error('La comisión final no puede ser menor que 0');
      } 
    } else {
      this.ajuste = true;
    }
  }
  
  accept=()=> {
    this.ajuste = false;
    this.viewStatus = 0;
    if(this.selectedCommission.creditId != null){
      // if(this.montoAjuste > 0){
      //   this.tipoAjuste = '-A';
      // } else{
      //   this.tipoAjuste = '-N';
      // }
      this.tipoAjuste = '-N';
  
      this.selectedCommission.commissionAdjustmentAmount=this.montoAjuste;
      this.selectedCommission.commissionFinalAmount = this.comisionOriginalFinal + this.montoAjuste;
      this.selectedCommission.createdUserId = localStorage.getItem("UserId");
      this.selectedCommission.comentario = this.comentarioAjuste;
      this.selectedCommission.iCreditIdMotivo = this.iCreditIdMotivo; 
      this.selectedCommission.claveEmpleadoDispersion =  this.selectedCommission.employeeId + '-' + this.formatDate(new Date()) + this.tipoAjuste;
  //this.selectedCommission.creditId + '-' +
  // EXISTENTE 
      console.log(">> INFO A ENVIAR 1: "+ JSON.stringify(this.selectedCommission));
      this.commissionService.saveCommissionAdjustment(this.selectedCommission)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.viewStatus = 1;
            this.ajuste = true;
            this.modalService.dismissAll(this.montoAjuste);
            this.toastr.success('El ajuste se ha guardado correctamente!');
          }
        });
    } else {
      //NUEVO
      let commissionAdditionalPromotor = new CommissionAdditionalPromotor();

      commissionAdditionalPromotor.employeeId = this.selectedCommission.employeeId;
      commissionAdditionalPromotor.employeeName = this.selectedCommission.employeeName;
      commissionAdditionalPromotor.fechaCobro = this.selectedCommission.executionDate;
      commissionAdditionalPromotor.capital = this.selectedCommission.capitalAmount;
      commissionAdditionalPromotor.commission = this.selectedCommission.commissionAmount;
      commissionAdditionalPromotor.commissionAdjustAmount = this.montoAjuste;
      commissionAdditionalPromotor.finalCommission = this.selectedCommission.commissionAmount + this.montoAjuste;
      commissionAdditionalPromotor.fechaSimulacion = this.simulateDate;
      commissionAdditionalPromotor.comment = this.comentarioAjuste;
      commissionAdditionalPromotor.createUser = localStorage.getItem("UserId");
      commissionAdditionalPromotor.enviado = 0;
  
      console.log(">> INFO A ENVIAR 2: "+ JSON.stringify(commissionAdditionalPromotor));
      this.commissionService.saveCommissionCaneAdditionalPromotor(commissionAdditionalPromotor)
        .subscribe((resp:any)=> {
          if(resp && resp.codeHttpStatus===200) {
            this.modalService.dismissAll(this.montoAjuste);
            this.toastr.success('El ajuste se ha guardado correctamente!');
          }
        });
    }    
  }

  cancel=()=> {
    this.modalService.dismissAll('failure');
    // console.log(this.montoAjuste);
    // if(this.montoAjuste != 0 || this.montoAjuste != undefined){
    //   this.modalService.dismissAll(this.montoAjuste);
    // } else {
    //   this.modalService.dismissAll(0);
    // }
  }

  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [day,month,year].join('');
  }

  
}